import React from 'react'
import PropTypes from 'prop-types'
import Svg from 'src/Components/Svg'

const propTypes = {
  className: PropTypes.string
}

const pink = '#FC5AA6'
const purple = '#322B41'

const Circle = props => <circle r='4' fill={purple} stroke={pink} {...props} />

const Component = props => (
  <Svg viewBox='20 165 600 150' {...props}>
    <path
      d='M624.8 217.03C583.51 172.73 430.42 129.85 332.17 239.26C233.93 348.67 204.75 302.65 159.09 273.68C113.44 244.72 63.79 236.63 19.23 268.45'
      fill='none'
      stroke={pink}
    />
    <Circle cx='65' cy='249.3' />
    <Circle cx='160' cy='274.3' />
    <Circle cx='236' cy='308' />
    <Circle cx='335' cy='236' />
    <Circle cx='440' cy='175.5' />
    <Circle cx='600' cy='198.5' />
  </Svg>
)

Component.propTypes = propTypes

export default Component
